import { render, staticRenderFns } from "./TreeBranch.vue?vue&type=template&id=982f4412"
import script from "./TreeBranch.vue?vue&type=script&lang=js"
export * from "./TreeBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports